<template>
  <div>
    <!-- 顶部区 -->
    <div class="top">
      <img src="../assets/banner2_m.jpg" />
      <div class="top_title">
        <span>欢迎合作联系</span>
      </div>
    </div>

    <div class="content">
      <div class='box'>
        <div class='title'>业务合作咨询</div>
        <div class="content_box">
          <img class="img_box" src='../assets/youxiang.png'/>
          <span style="line-height: 100px;">邮箱：c@feedying.com</span>
        </div>
        <!-- <div class="content_box" style="margin-top: 20px;">
          <img class="img_box" src='../assets/shouji.png'/>
          <span style="line-height: 100px;">手机：18879750291</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
// 顶部区
.top{
  width: 100%;
  height: 300px;
  position:relative;
  img{
    width: 100%;
    height:300px;
  }
  .top_title{
    letter-spacing:2px;
    text-align: center;
    position:absolute;
    color:#FFFFFF;
    top:50px;
    left: 51%;
    transform: translate(-49%,0);// 左右居中
    width:100%;
    font-size:22px;      
  }
}

// 内容
.content{
  background-color: #F8F8F8;
  padding-bottom: 30px;
  // 标题
  .title{
    font-size:18px;
    padding: 25px 0;
    text-align: center;
    color:#333333;
  }
  .content_box{
    // text-align: center;
    padding-left: 80px;
    box-sizing: border-box;
    width: 100%;
    background-color: white;
    border-radius: 5px;
    .img_box{
      width: 30px;
      vertical-align: middle;
      margin-right: 10px;
    }
  }
}
</style>